<template>
  <div class="my-4">
    <safe-icon class="align-middle" />
    <span class="align-middle inline-block ml-1 text-lg" style="color: #808490"
      >个人信息完善：手机号</span
    >
    <span class="block mt-2 text-gray-400 text-sm w-full md:w-1/3 ">{{ desc }}</span>

    <span v-if="type === 'agreed'" class="status success">
      <right-icon class="inline-block" style="margin-top: -2px" />
      手机号已关联成功
    </span>

    <span v-else-if="type === 'refused'" class="status error">
      已跳过手机号关联
    </span>

    <div v-show="visible" class="modal">
      <div class="mask"></div>
      <div v-if="!defaultPhone" class="modal-content">
        <div class="modal-title">个人信息完善：手机号关联</div>
        <div class="modal-body">
          <div class="modal-body-main">
            <span class="text-lg mb-2 block">{{ mainBody }} 申请</span>
            <span class="desc">{{ desc }}</span>
            <div class="modal-phone">
              <input
                v-model="phone.value"
                class="ipt-phone w-full border-transparent"
                :class="{
                  rounded: !defaultPhone,
                  'rounded-tl': defaultPhone,
                  'rounded-bl': defaultPhone
                }"
                type="tel"
                placeholder="请输入手机号"
                maxlength="11"
                required
              />
              <span
                class="ipt-phone-addon-after"
                :style="{ right: !userInfo || !userInfo.phone ? '20px' : '140px' }"
                @click="onClear"
              ></span>
            </div>
            <div class="modal-code">
              <input
                v-model="sms.value"
                type="number"
                class="ipt-code rounded-tl rounded-bl border-transparent"
                :style="{ width: 'calc(100% - 120px)' }"
                placeholder="请输入验证码"
                required
              />
              <button class="btn-code" @click="onSendSMS">{{ smsText }}</button>
            </div>
          </div>

          <div class="button-group">
            <button class="btn cancel" @click="onCancel">取消</button>
            <button class="btn ok" @click="onOk">提交</button>
          </div>
        </div>
      </div>
      <div v-else class="modal-content binded">
        <div class="modal-title">个人信息完善：手机号关联</div>
        <div class="mb-6">
          <success-icon width="60" height="60" class="mb-4 mt-10 block mx-auto" />
          <span class="text-2xl block text-center w-full mb-4">已关联手机号</span>
          <div class="flex flex-col justify-center text-center space-y-2">
            <span class="text-gray-400">
              当前账号已关联
              {{ defaultPhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }} 号码
            </span>
            <span class="text-gray-400">
              可前往
              <a href="/account/safety" class="text-motif-500" target="_blank">个人中心</a>
              修改手机号
            </span>
          </div>
        </div>
        <div class="button-group w-full">
          <button class="btn cancel" @click="onSkip">已了解</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import RightIcon from '../PhoneAuth/assets/RightIcon.vue';
import SafeIcon from '../PhoneAuth/assets/SafeIcon.vue';
import SuccessIcon from '../PhoneAuth/assets/SuccessIcon.vue';
import { UtteranceControl } from '@/components/resources';
import { namespace } from 'vuex-class';
import { Auth, AuthStatus, UserInfo } from '@/store/modules/common/types';
import { Content } from '@forchange/storytime';
import { INVALID_PHONE_MSG } from '@/utils/constant';
import * as Sentry from '@sentry/vue';

const userModule = namespace('common');

const BUTTON_SMS_DEFAULT = '发送验证码';

@Component({
  components: {
    RightIcon,
    SafeIcon,
    SuccessIcon,
    UtteranceControl
  },
  name: 'PhoneBind'
})
export default class PhoneAuth extends Vue {
  @Prop({ type: Object })
  content!: Content & {
    desc?: string;
    mainBody?: string;
  };

  @userModule.State('userInfo') public userInfo: UserInfo;

  @userModule.State('auth') public auth!: Auth;

  type: AuthStatus = '';
  phone = {
    error: false,
    value: ''
  };

  sms = {
    error: false,
    value: '',
    countdown: 60
  };

  visible = true;

  timer = 0;

  @Watch('auth.phone.status', { immediate: true })
  phoneAuthChanged(value: AuthStatus, oldValue: AuthStatus) {
    if (value !== '') {
      this.visible = false;
      this.type = value;
    }
  }

  @Watch('content.input', { immediate: true })
  inputChange(value: any) {
    if (value) {
      this.type = value;
      this.visible = false;
    }
  }

  get defaultPhone() {
    return this.userInfo && this.userInfo.phone;
  }

  get desc() {
    return (
      this.content?.desc ||
      '关联手机号，方便再次进行学习使用手机号快捷登录系统，提升账号完整性、安全性。'
    );
  }

  get mainBody() {
    return this.content?.mainBody || '风变课灵小馆';
  }

  get smsText() {
    if (this.timer) {
      return `${this.sms.countdown}s后再次发送`;
    }
    return BUTTON_SMS_DEFAULT;
  }

  onClear() {
    this.phone.value = '';
  }

  changeControlStatus(status: AuthStatus) {
    this.$store.commit('common/setBind', {
      key: 'phone',
      status
    });

    // window.$tracker?.authPhone({
    //   resource_id: this.content.$id,
    //   desc: this.desc,
    //   mainBody: this.mainBody,
    //   status: status as 'agreed' | 'refused',
    //   phone: status === 'agreed' ? this.phone.value : ''
    // });
  }

  onCancel() {
    this.visible = false;
    this.type = 'refused';
    this.changeControlStatus('refused');
    window.storyteller.input('refused');
  }

  onSkip() {
    this.visible = false;
    this.type = 'agreed';
    this.changeControlStatus('agreed');
    window.storyteller.input('agreed');
  }

  onSendSMS() {
    if (this.timer) {
      return;
    }

    const isValidPhone = /^(?:(?:\+|00)86)?1\d{10}$/.test(this.phone.value.trim());

    if (isValidPhone) {
      this.$PostConnection
        ?.command('update_phone__sms', {
          phone: this.phone.value
        })
        .catch((err: any) => {
          this.$Message.error({ content: `发送验证码失败，${err.message}` });
          Sentry.captureMessage(`[SMS fail]: ${this.phone.value} - ${err.message}`);
        });
      this.phone.error = false;
      this.timer = window.setInterval(() => {
        if (this.sms.countdown === 1) {
          this.sms.countdown = 60;
          window.clearInterval(this.timer);
          this.timer = 0;
        } else {
          this.sms.countdown = this.sms.countdown - 1;
        }
      }, 1000);
    } else {
      this.phone.error = true;
      this.$Message.error({ content: INVALID_PHONE_MSG, time: 3000 });
    }
  }

  onOk() {
    if (this.phone.error) {
      this.$Message.error({ content: INVALID_PHONE_MSG, time: 3000 });
      return;
    }

    // 发送事件给顶层 Cleword，让 Cleword 执行 authingsdk-updatePhone 方法
    this.$PostConnection
      ?.command('update_phone', {
        phone: this.phone.value,
        sms: this.sms.value
      })
      .then((res: any) => {
        console.log(res);
        this.$Message.success({ content: `手机号关联成功`, time: 3000 });
        this.phone = {
          value: '',
          error: false
        };
        this.sms = {
          value: '',
          error: false,
          countdown: 60
        };
        this.type = 'agreed';
        this.visible = false;
        this.changeControlStatus('agreed');
        window.storyteller.input('agreed');
      })
      .catch((err: any) => {
        this.$Message.error({ content: `${err.message}`, time: 3000 });
        this.sms.value = '';
        Sentry.captureMessage(`[Update_User fail]: ${err.message}`);
      });
  }
}
</script>

<style scoped>
/* .modal {
} */
.status {
  @apply text-white py-1 px-2 mt-2 w-1/3 block rounded-md text-sm md:w-1/5;
}
.status.success {
  @apply bg-green-500;
}
.status.error {
  /* @apply bg-amber-500; */
  @apply bg-yellow-500;
}

.mask {
  @apply bg-black absolute left-0 right-0 top-0 bottom-0 opacity-30;
}
.divide {
  @apply block bg-gray-200 my-2;
  height: 1px;
}

.modal-content {
  @apply w-full bg-white p-6 box-border rounded-t-lg flex flex-col absolute left-0 bottom-0 transform z-20;
  min-height: 300px;
}

.modal-content .modal-body {
  @apply flex flex-col;
  height: 220px;
}
.modal-content .modal-body-main {
  @apply flex-1;
}
.modal-content .modal-title {
  @apply text-2xl text-gray-800 font-bold mb-6;
}
.modal-content .desc {
  @apply text-gray-500 block;
}

.modal-content .modal-phone {
  @apply relative  mt-6;
}

.modal-content .modal-code {
  @apply relative mt-4;
}

.modal-content .ipt-phone,
.modal-content .ipt-code {
  @apply bg-gray-100 pr-2 pl-4 py-3 relative;
  height: 44px;
  /* width: ; */
}

.modal-content .ipt-code::-webkit-inner-spin-button {
  appearance: none;
}

.modal-content .ipt-phone:placeholder-shown + .ipt-phone-addon-after {
  @apply hidden;
}
.modal-content .modal-code .btn-code {
  @apply absolute py-3 bg-gray-200 right-0 rounded-tr rounded-br;
  width: 120px;
  height: 44px;
}
.modal-content .ipt-phone-addon-after {
  @apply absolute top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full bg-no-repeat bg-center box-border inline-block cursor-pointer z-20;
  width: 16px;
  height: 16px;
  background-image: url('../../../select-menu/assets/close.svg');
  background-size: 50%;
}

.button-group {
  @apply flex justify-around w-full mt-2;
}
.btn {
  @apply border-gray-400 font-normal;
  width: 160px;
}
.btn:hover {
  @apply opacity-90;
}
.btn.cancel {
  @apply bg-gray-200;
}
.btn.ok {
  @apply bg-motif-500 text-white;
}

@screen md {
  .modal-content {
    @apply rounded-lg left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2;
    width: 440px;
  }

  .modal-content .modal-body {
    height: 320px;
  }
}
</style>
